import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    HWAIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={HWAIconImg} preview={false}/>
